import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { StorageTypesComponent } from './manage-storage-type.component';

const routes: Routes = [
  { path: '', component: StorageTypesComponent, data: { title: 'Manage Storage Types' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageStorageTypeRoutingModule {}

@NgModule({
  imports: [
    ManageStorageTypeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [StorageTypesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageStorageTypeModule {}
